<script setup lang="ts">
import { PropType } from 'vue';
import {
    B4ExprInput,
    type PredicateValueInputMethod,
} from '@precon-tools-suite-by-shared/primevue-predicate-expressions';
import PredicateSelect, { MaybeOwnedPredicate } from './PredicateSelect.vue';
import {
    Field,
    fieldPropDefs,
    useFieldProps,
} from '@precon-tools-suite-by-shared/shared-common-forms-ui';

const props = defineProps({
    ...fieldPropDefs,
    valueInputMethod: {
        type: String as PropType<PredicateValueInputMethod>,
        default: 'dropdown',
    },
    modelValue: {
        type: String,
        default: () => 'I',
    },
    options: {
        type: Array<MaybeOwnedPredicate>,
        default: () => [],
    },
    showOwner: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);

const { fieldProps, modelValue } = useFieldProps(props, emit);
</script>
<template>
    <Field v-bind="fieldProps">
        <template #readonly>
            <B4ExprInput v-model:model-value="modelValue" :readonly="true">
                <template #term="slotProps">
                    <div v-if="loading">
                        <Skeleton />
                    </div>
                    <div
                        v-else
                        class="expression-builder-readonly"
                        v-html="
                            options
                                .filter((o) => o.id === slotProps.modelValue)
                                .map((o) => o.predicateQuestion)[0] ??
                            '<i>-- geen waarde --</i>'
                        "
                    />
                </template>
            </B4ExprInput>
        </template>
        <div v-if="loading">
            <Skeleton />
        </div>
        <div v-else>
            <B4ExprInput
                v-model:model-value="modelValue"
                :value-input-method="valueInputMethod"
                test-tautologies
                test-contradictions
            >
                <template #term="slotProps">
                    <PredicateSelect
                        v-bind="slotProps"
                        :options="options"
                        style="width: 100%"
                        :show-owner="showOwner"
                        :loading="loading"
                    />
                </template>
            </B4ExprInput>
        </div>
    </Field>
</template>

<style lang="scss">
.expression-builder-readonly {
    border: 1px solid var(--surface-border);
    border-radius: var(--border-radius);
    padding: 0.75rem;
    background-color: var(--surface-a);
}
</style>
